<!-- 新增商品 -->
<template>
  <div class="product-release">
    <!-- <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 商品新增 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>-->
    <div class="product-tab-btn">
      <div class="btn-item">
        <el-button
          size="mmedium"
          type="primary"
          @click="goToUrl('/createProductsMain')"
        >
          <i>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.3741 0.0699348C19.1041 -0.0400652 18.8042 -0.0100652 18.5543 0.109935L18.5443 0.0999348L0.549831 9.09994C0.209936 9.26994 0 9.61994 0 9.99994C0 10.3799 0.209936 10.7199 0.549831 10.8899L6.05814 13.6499C6.08813 13.5599 6.13812 13.4699 6.1981 13.3899L7.25777 12.0099L4.80852 10.7799L4.69856 10.7299L3.23901 9.99994L15.5552 3.83993L8.21748 13.3899C8.06752 13.5599 7.99755 13.7699 7.99755 13.9999V19.9999H9.99693V14.3399L17.5746 4.47993L16.165 16.4699L11.9963 14.3799V16.6199L13.3659 17.2999L16.5549 18.8899C16.8448 19.0299 17.1847 19.0299 17.4746 18.8799C17.7645 18.7299 17.9545 18.4399 17.9945 18.1199L19.9939 1.11993C20.0438 0.669935 19.7839 0.239935 19.3741 0.0699348Z"
                fill="white"
              />
            </svg>
          </i>
          在线填写发布
        </el-button>
        <span @click="linkSingleVideo">在线填写发布演示视频</span>
      </div>
      <div class="btn-item">
        <el-button
          size="mmedium"
          type="primary"
          @click="goToUrl('/createBatchProducts')"
        >
          <i>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.3741 0.0699348C19.1041 -0.0400652 18.8042 -0.0100652 18.5543 0.109935L18.5443 0.0999348L0.549831 9.09994C0.209936 9.26994 0 9.61994 0 9.99994C0 10.3799 0.209936 10.7199 0.549831 10.8899L2.86912 12.0499L0.549831 13.2099C0.209936 13.3799 0 13.7299 0 14.1099C0 14.4899 0.209936 14.8299 0.549831 14.9999L6.05814 17.7599C6.08813 17.6699 6.13812 17.5799 6.1981 17.4999L7.25777 16.1199L4.80852 14.8999L4.69856 14.8399L3.22901 14.1099L5.10843 13.1699L6.06814 13.6499C6.09813 13.5599 6.14811 13.4699 6.2081 13.3899L7.26777 12.0099L4.81852 10.7799L4.69856 10.7299L3.23901 9.99994L15.5552 3.83993L8.21748 13.3899C8.06752 13.5599 7.99755 13.7699 7.99755 13.9999V19.9999H9.99693V14.3399L17.5746 4.47993L16.165 16.4699L11.9963 14.3799V16.6199L13.3659 17.2999L16.5549 18.8899C16.8448 19.0299 17.1847 19.0299 17.4746 18.8799C17.7645 18.7299 17.9545 18.4399 17.9945 18.1199L19.9939 1.11993C20.0438 0.669935 19.7839 0.239935 19.3741 0.0699348Z"
                fill="white"
              />
            </svg>
          </i>
          数据导入发布
        </el-button>
        <span @click="linkMultipleVideo">数据导入发布演示视频</span>
      </div>
      <div v-if="isGoUrl" class="btn-item">
        <el-button
          size="mmedium"
          type="primary"
          :disabled="!isGoUrl"
          @click="goUrl('/createProductsMain', 'chooseFlag')"
        >
          <i>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.3741 0.0699348C19.1041 -0.0400652 18.8042 -0.0100652 18.5543 0.109935L18.5443 0.0999348L0.549831 9.09994C0.209936 9.26994 0 9.61994 0 9.99994C0 10.3799 0.209936 10.7199 0.549831 10.8899L2.86912 12.0499L0.549831 13.2099C0.209936 13.3799 0 13.7299 0 14.1099C0 14.4899 0.209936 14.8299 0.549831 14.9999L6.05814 17.7599C6.08813 17.6699 6.13812 17.5799 6.1981 17.4999L7.25777 16.1199L4.80852 14.8999L4.69856 14.8399L3.22901 14.1099L5.10843 13.1699L6.06814 13.6499C6.09813 13.5599 6.14811 13.4699 6.2081 13.3899L7.26777 12.0099L4.81852 10.7799L4.69856 10.7299L3.23901 9.99994L15.5552 3.83993L8.21748 13.3899C8.06752 13.5599 7.99755 13.7699 7.99755 13.9999V19.9999H9.99693V14.3399L17.5746 4.47993L16.165 16.4699L11.9963 14.3799V16.6199L13.3659 17.2999L16.5549 18.8899C16.8448 19.0299 17.1847 19.0299 17.4746 18.8799C17.7645 18.7299 17.9545 18.4399 17.9945 18.1199L19.9939 1.11993C20.0438 0.669935 19.7839 0.239935 19.3741 0.0699348Z"
                fill="white"
              />
            </svg>
          </i>
          在线选取保供平台数据
        </el-button>
        <div style="height: 32px"></div>
      </div>
    </div>
    <div class="wran-msg">
      <span class="bold">重要提示：</span>
      <p class="warning-text">
        供应商不得在易派客平台发布危险物品及无人机相关商品信息或建立相关链接。根据《互联网危险物品信息发布管理规定》的规定，危险物品是指枪支弹药、爆炸物品、剧毒化学品、易制爆危险化学品和其他危险化学品、放射性物品、核材料、管制器具及相关商品等能够危及人身安全和财产安全的物品；《无人驾驶航空器飞行管理暂行条例》无人驾驶航空器是指没有机载驾驶员、自备动力系统的航空器；按照性能指标分为微型、轻型、小型、中型和大型。请悉知。
      </p>
    </div>
    <!-- 搜索组件 -->
    <e-search
      :count="filterInfo.count"
      :data="filterInfo.data"
      :field-list="filterInfo.fieldList"
      :list-type-info="listTypeInfo"
      class="product-search"
      @handleFilter="handleFilter"
      @handleReset="handleReset"
    ></e-search>

    <div class="handle-tabe-box">
      <!-- 操作 -->
      <div class="handle-box">
        <el-button
          :disabled="multipleSelection.length === 0"
          @click="openAsImgsDialog"
        >
          维护图片
        </el-button>
        <el-button
          :disabled="multipleSelection.length === 0"
          @click="setAreaRule"
        >
          设置可售区域
        </el-button>
        <el-button
          btn-txt
          :disabled="multipleSelection.length === 0"
          @click="handleCheck"
        >
          提交审核
        </el-button>
        <el-button
          :disabled="multipleSelection.length === 0"
          @click="batchDelHandle"
        >
          批量删除
        </el-button>
      </div>
      <div class="table-box">
        <!-- 列表 -->
        <el-table
          ref="tableData"
          v-loading="tableLoading"
          :data="tableData"
          border
          row-key="productAuditId"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            fixed="left"
            :reserve-selection="true"
            width="36"
          ></el-table-column>
          <el-table-column
            prop="defaultImage"
            label="商品图片"
            fixed="left"
            width="80"
            color="#333333"
          >
            <template slot-scope="{ row }">
              <el-image
                v-if="row.defaultImage"
                class="default-img"
                :src="row.defaultImage"
                :preview-src-list="[row.defaultImage]"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            label="商品名称"
            fixed="left"
            min-width="280"
            align="center"
          >
            <template slot-scope="{ row }">
              <el-link
                style="justify-content: start; width: 100%; text-align: left"
                type="primary"
                @click="goToUrl('/productDetail', row.productAuditId)"
              >
                {{ row.skuName }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="brandName"
            label="品牌"
            align="center"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="categoryName"
            label="所属分类"
            min-width="150"
            align="center"
          ></el-table-column>
          <el-table-column label="是否有图" min-width="70" align="center">
            <template slot-scope="{ row }">
              {{ row.ifImage === 1 ? '是' : row.ifImage === 0 ? '否' : '' }}
            </template>
          </el-table-column>
          <el-table-column label="销售范围" min-width="90" align="center">
            <template slot-scope="{ row }">
              <span>
                {{
                  row.salesScope === 1
                    ? '全平台'
                    : row.salesScope === 2
                    ? '仅协议客户'
                    : ''
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="提交状态" min-width="90" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.auditStatus === 103">{{
                row.auditStatus | auditStatusFliter
              }}</span>
              <el-tooltip
                v-else
                hover
                :class="{ error: row.auditStatus === 105 }"
                effect="dark"
                placement="top-start"
              >
                <span slot="content">{{ row.errorMessage }}</span>
                <span>{{ row.auditStatus | auditStatusFliter }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="updateTime"
            label="创建时间"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="unitValue"
            label="计量单位"
            min-width="90"
            align="center"
          ></el-table-column>
          <el-table-column
            label="价格(元)"
            min-width="90"
            align="center"
            prop="price"
          ></el-table-column>
          <el-table-column label="操作" fixed="right" width="90" align="center">
            <template slot-scope="scope">
              <eui-btn
                type="text"
                @click="
                  goToUrl(
                    '/productEdit?currentIndex=2',
                    scope.row.productAuditId
                  )
                "
              >
                编辑
              </eui-btn>
              <eui-btn
                type="text"
                @click="previewProduct(scope.row.productAuditId)"
              >
                预览
              </eui-btn>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-box">
          <el-pagination
            :page-sizes="[10, 20, 30]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="listQuery.pageNum"
            :total="total"
            :page-size.sync="listQuery.pageSize"
            prev-text="上一页"
            next-text="下一页"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 设置运费规则弹窗 -->
    <area-dialog
      ref="areaForm"
      :area-form-visible.sync="areaFormVisible"
      :area-arr="areaArr"
      @areaHandle="areaHandle"
    />
    <!-- 维护图片弹窗 -->
    <associated-images
      ref="uploadImage"
      :associated-images-visible.sync="associatedImagesVisible"
      @getAllImageUrls="getAllImageUrls"
    />

    <previewDialog
      :dialog-visible.sync="previewProductVisible"
      :product-audit-id="productAuditId"
    ></previewDialog>
  </div>
</template>

<script>
import AssociatedImages from '../components/associatedImages.vue';
import AreaDialog from './components/areaDialog.vue';
import eSearch from '../../../components/common/e-search';
import api from '../../../api/product';
import utils from '../../../utils/utils';
import { videoUrl } from '../../../api/config.js';

import previewDialog from '../components/productDetail/previewDialog.vue';

export default {
  name: 'CreateProduct',

  components: {
    eSearch,
    AreaDialog,
    AssociatedImages,
    previewDialog,
  },
  filters: {
    auditStatusFliter(value) {
      if (!value) {
        return '';
      }
      return value === 103 ? '未提交 ' : value === 105 ? '提交失败' : '';
    },
  },
  data() {
    return {
      // 维护图片弹窗
      associatedImagesVisible: false, // 预览弹窗
      // 区域数组
      areaArr: [],
      areaFormVisible: false,
      // 列表数据
      tableData: [],
      // 总条数
      total: 0,
      // 搜索参数
      listQuery: {
        pageNum: 1,
        pageSize: 10,
      },

      tableLoading: false,
      cloneListQuery: {},
      isShow: true,
      filterInfo: {
        count: 100,
        data: {
          skuName: '',
          skuCode: '',
          salesScopeId: '',
          categoryName: '',
          brandName: '',
          submitStatus: '',
          createTime: '',
          ifImag: '',
        },
        fieldList: [
          {
            label: '商品名称',
            type: 'input',
            value: 'skuName',
          },
          /* { label: "商品编号", type: "input", value: "skuCode" }, */
          {
            label: '可售区域',
            type: 'select',
            value: 'salesScopeId',
            list: 'salesScopeList',
          },
          {
            label: '所属分类',
            type: 'input',
            value: 'categoryName',
          },
          {
            label: '品牌',
            type: 'input',
            value: 'brandName',
          },
          {
            label: '提交状态',
            type: 'select',
            value: 'auditStatus',
            list: 'auditStatusList',
          },
          {
            label: '创建时间',
            type: 'date',
            value: 'createTime',
            dateType: 'daterange',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '是否有图',
            type: 'select',
            value: 'ifImage',
            list: 'ifImagArr',
          },
        ],
        /** 配置项 */
        btnStyle: [
          {
            icon: 'el-icon-search',
            text: '过滤',
            type: 'primary',
          },
          {
            icon: 'el-icon-refresh',
            text: '重置',
          },
        ],
      },
      listTypeInfo: {
        auditStatusList: [
          {
            id: 103,
            name: '未提交',
          },
          {
            id: 105,
            name: '提交失败',
          },
        ],
        ifImagArr: [
          {
            id: 1,
            name: '是',
          },
          {
            id: 0,
            name: '否',
          },
        ],
        salesScopeList: [],
      },

      // 新增参数
      showListVisible: false,
      multipleSelection: [],
      // 图片弹窗信息
      imgDialogVisible: false,
      imageUrls: [], // 主图文件列表
      detailImageUrls: [], // 详情图列表
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      isShowTree: false,
      // 判断能否跳转保供平台
      isGoUrl: true,
      previewProductVisible: false,
      productAuditId: 0,
    };
  },

  created() {
    const { cloneDeep } = utils;
    this.cloneListQuery = cloneDeep(this.listQuery);
    this.getList(this.listQuery);
    this.getAreaArr();
    this.getIsSelect();
  },
  activated() {
    this.getList(this.listQuery);
  },
  methods: {
    previewProduct(productAuditId) {
      this.productAuditId = productAuditId;
      this.previewProductVisible = true;
    },
    linkSingleVideo() {
      window.open(`${videoUrl}/eCourse/detail?lessonId=4&categoryId=7`);
    },
    linkMultipleVideo() {
      window.open(`${videoUrl}/eCourse/detail?lessonId=59&categoryId=7`);
    },
    getRowKey(row) {
      return row.productAuditId;
    },
    // 判断能否跳转保供平台
    async getIsSelect() {
      try {
        const { isSelect } = api;
        const result = await isSelect();
        this.isGoUrl = result.data === 1;
      } catch (err) {
        console.log(err);
      }
    },
    // 维护图片
    openAsImgsDialog() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需要处理的列表数据',
          type: 'warning',
        });
        return;
      }
      this.associatedImagesVisible = true;
      this.$refs.uploadImage.initData();
    },
    // 维护图片
    async getAllImageUrls(val) {
      const productAuditIds = this.multipleSelection.map(
        (item) => item.productAuditId
      );
      const params = {
        productAuditIds,
      };
      params.defaultImage = val.imageUrls[0] || val.imageUrlsExist[0];
      Object.assign(params, val);
      const { unsubmitReleaseImagesUpdate } = api;
      const res = await unsubmitReleaseImagesUpdate(params);
      if (+res.code === 200) {
        this.$message({
          message: '维护图片成功！',
          type: 'success',
        });
        this.getList(this.listQuery);
        this.$refs.tableData.clearSelection();
        this.associatedImagesVisible = false;
      }
    },
    // 获取区域列表
    async getAreaArr() {
      const { querySalesScopeList } = api;
      await querySalesScopeList()
        .then((res) => {
          if (res.code === '200') {
            const data = [...res.data]; // salesScopeName/salesScopeId
            const list = data.map((item) => ({
              id: item.salesScopeId,
              name: item.salesScopeName,
            }));
            this.areaArr = [...data];
            this.listTypeInfo.salesScopeList = [...list];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 设置运费规则
    setAreaRule() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需要设置的数据',
          type: 'warning',
        });
        return;
      }
      this.areaFormVisible = true;
    },
    // 设置可售区域-确定操作
    async areaHandle(salesScopeId) {
      const unsubmitReleaseAO = {};
      unsubmitReleaseAO.salesScopeId = salesScopeId;
      unsubmitReleaseAO.productAuditIds = this.multipleSelection.map(
        (item) => item.productAuditId
      );
      await api
        .unsubmitReleaseSalesScopeUpdate(unsubmitReleaseAO)
        .then((res) => {
          if (res.code === '200') {
            this.$message({
              message: '可售区域设置成功',
              type: 'success',
            });
            this.getList(this.listQuery);
            this.$refs.tableData.clearSelection();
            this.areaFormVisible = false;
          }
        });
    },
    // 批量审核操作
    handleCheck() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需要处理的数据',
          type: 'warning',
        });
        return;
      }
      this.$confirm(
        '提交后由平台人员审核，审核状态可进入商品维护查看。',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      )
        .then(() => {
          // 1是有图，0否没有图
          const noImageArr = this.multipleSelection.filter(
            (item) => item.ifImage === 0
          );
          if (noImageArr.length !== 0) {
            this.$message({
              message:
                '所选商品中存在没有维护图片的商品，请先维护图片，再提交审核！',
              type: 'warning',
            });
          } else {
            const ids = this.multipleSelection.map(
              (item) => item.productAuditId
            );
            api.unsubmitProductReleaseBattch(ids).then((res) => {
              if (res.code === '200') {
                const { data } = res;

                this.listQuery.pageNum = 1;
                this.getList(this.listQuery);
                this.$refs.tableData.clearSelection();
                this.multipleSelection = [];
                /* 
                  (data.errorCount === 1) {
                    this.$message({
                      type: "warning",
                      message: data.errorContent,
                    });
                  } else 
                */
                if (data.errorCount > 1) {
                  this.$message({
                    type: 'warning',
                    message:
                      '您好！提交商品中，部分因存在问题提交失败，可在列表中查看。',
                  });
                } else {
                  this.$message({
                    type: 'success',
                    message: '提交成功，可在商品维护列表查看商品审核进度。',
                  });
                  this.$router.push({
                    path: '/goodsMaintenance',
                    query: { currentIndex: 2 },
                  });
                }
              }
            });
          }
        })
        .catch(() => {});
    },

    // 批量删除操作
    batchDelHandle() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: '请选择需要删除的数据',
          type: 'warning',
        });
        return;
      }
      this.$confirm('删除后不可恢复，确认要删除商品吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          const productAuditIds = this.multipleSelection.map(
            (item) => item.productAuditId
          );
          api
            .unsubmitReleaseDelete(productAuditIds)
            .then((res) => {
              if (res.code === '200') {
                this.listQuery.pageNum = 1;
                this.getList(this.listQuery);
                this.$refs.tableData.clearSelection();
                this.$message({
                  type: 'success',
                  message: '删除成功!',
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    // 搜索
    handleFilter(val) {
      this.$refs.tableData.clearSelection();
      if (val.createTime.length) {
        val.startTime = val.createTime[0];
        val.endTime = val.createTime[1];
      } else {
        delete val.startTime;
        delete val.endTime;
      }
      Object.assign(this.listQuery, val);
      this.listQuery.pageNum = 1;
      this.getList(this.listQuery);
    },
    // 重置
    handleReset() {
      this.$refs.tableData.clearSelection();
      this.listQuery = {
        ...this.cloneListQuery,
      };
      this.getList(this.listQuery);
    },

    goUrl(url, chooseFlag) {
      this.$router.push({
        path: url,
        query: {
          productAuditId: chooseFlag,
        },
      });
    },
    // 跳转链接
    goToUrl(url, productAuditId) {
      productAuditId
        ? this.$router.push({
            path: url,
            query: {
              productAuditId: `${productAuditId}x`,
            },
          })
        : this.$router.push({
            path: url,
          });

      /* this.$router.push({
				  name: "productEdit",
				  params: { productAuditId },
				}); */
    },

    // 获取列表数据
    async getList(params) {
      try {
        this.tableLoading = true;
        const res = await api.queryUnsubmitProductAuditByPage(params);
        this.tableLoading = false;
        if (res.code === '200') {
          const { data } = res;
          this.tableData = [...data.records];
          this.total = data.total;
          // 选中置空
          // this.$refs.tableData.clearSelection();
        }
      } catch (err) {
        console.log(err, '错误了');
      }
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 上传文件格式一律转为小写
    commonHandleCheck(val) {
      let testmsg = val.substring(val.lastIndexOf('.') + 1);
      testmsg && (testmsg = testmsg.toLowerCase());
      return testmsg;
    },
    // 上传之前图片验证
    beforeUpload(file) {
      const testmsg = this.commonHandleCheck(file.name);
      const isJPEG = testmsg === 'jpeg';
      const isJPG = testmsg === 'jpg';
      const isPNG = testmsg === 'png';
      const isGIF = testmsg === 'gif';
      const isLt8M = file.size / 1024 / 1024 < 4;
      if (!isJPG && !isPNG && !isGIF && !isJPEG) {
        this.$message.error('上传图片只能是 JPG、JPEG、PNG、GIF 格式!');
        return false;
      }
      if (!isLt8M) {
        this.$message.error('上传图片大小不能超过 4MB!');
        return false;
      }
      return isJPG || isPNG || isGIF || isJPEG;
    },
    // 点击是否展示列表项设置
    showListHandle() {
      this.showListVisible = !this.showListVisible;
    },
  },
};
</script>
<style lang="scss" scoped>
.product-release {
  /* 公共样式 */
  ::v-deep .el-table__row .cell {
    font-size: 12px;
    white-space: normal;
    padding-left: 6px;
    padding-right: 6px;

    /* overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2; 
    -webkit-box-orient: vertical;
    .el-link {
      overflow: hidden;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-line-clamp: 2; 
      -webkit-box-orient: vertical;
    } */
    .el-button {
      font-size: 12px;
    }
  }

  ::v-deep .el-table--small td,
  ::v-deep .el-table--small th {
    padding: 6px 0;
  }

  ::v-deep .el-table--small .el-table-column--selection {
    .cell {
      padding-left: 10px;
      padding-right: 10px;

      .el-checkbox__inner {
        border-radius: 0;
      }
    }
  }

  ::v-deep .el-image {
    width: 48px;
    height: 48px;
    display: block;
    font-size: 0;

    ::v-deep img {
      display: block;
      width: 100%;
      width: 100%;
    }
  }

  ::v-deep .el-message-box {
    border-radius: 0;
  }

  /* 公共样式结束 */

  .wran-msg {
    background: #fff;
    padding: 20px 10px 10px 10px;
    color: #f0250f;
    font-size: 14px;
    display: flex;
    flex-flow: row;
    .bold {
      display: inline-block;
      width: 110px;
      font-weight: bold;
      text-align: right;
      color: #333;
      flex-shrink: 0;
    }
    .warning-text {
     font-size: 16px;
     font-weight: 500;
     line-height: 20px;
    }
  }
  padding: 10px;

  /* .container {
    margin-bottom: 10px;
    .sku-img {
      width: 70px;
      height: 70px;
    }
    .el-checkbox-group {
      display: flex;
      flex-flow: column;
    }
    ::v-deep .el-table thead {
      color: #333333;
    }
  } */
  .handle-content {
    margin-bottom: 10px;
  }

  .table-box {
    //   margin-bottom: 20px;
  }

  .product-tab-btn {
    display: flex;
    align-items: center;
    justify-content: center;

    .btn-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span {
        line-height: 1;
        margin: 10px 0;
        color: #0064c8;
        font-size: 12px;
        i {
          position: relative;
          top: 4px;
          margin-right: 10px;
        }

        &:hover {
          // text-decoration: underline;
          cursor: pointer;
        }
      }

      & + .btn-item {
        margin-left: 40px;
      }

      ::v-deep .el-button {
        width: 260px;
        height: 44px;
        line-height: 44px;
        padding: 0;
        font-size: 14px;
        border-radius: 0;
        &:hover {
          background: #126edf;
        }
      }
    }
  }

  .product-search {
    padding: 10px;
    background: #fff;

    ::v-deep .item-style {
      margin: 0;
      margin-bottom: 10px;
    }
  }

  .handle-tabe-box {
    margin-top: 20px;
    padding: 20px;
    background: #fff;

    .handle-box {
      margin-bottom: 10px;

      ::v-deep .el-button {
        height: 30px;
      }

      .delete {
        color: #c5c5c5;
      }
    }

    /* 可以提出去 */
    .table-box {
      ::v-deep .el-table {
        .el-table__header {
          thead {
            color: #333;

            th {
              background-color: #f5f5f5 !important;
            }
          }
        }
      }
    }

    .pagination-box {
      text-align: right;
      margin-top: 20px;
      margin-bottom: 0;
      ::v-deep .el-pagination {
        button {
          height: 30px;
          color: #999;
        }
        .el-select {
          .el-input__inner {
            border-radius: 0;
            height: 30px;
          }
        }
        .el-input__inner {
          border-radius: 0;
          height: 30px;
          color: #999;
        }
        .el-select-dropdown__item,
        .el-pagination__jump,
        .el-pagination__total {
          color: #999;
        }
        .el-pager {
          li {
            border-radius: 0;
            border: 1px solid #d9d9d9;
            line-height: 28px;
            text-align: center;
            margin-left: 10px;
            width: 40px;
            height: 30px;
            color: #999;
            &:first-child {
              margin-left: 0;
            }
          }
          .active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }

  .crumbs {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
    position: relative;
  }

  .set-list {
    min-height: 100px;
    position: absolute;
    /* width: 100px; */
    z-index: 100;
    right: 0;
    background: #fff;
    border: 1px solid #ddd;
    padding: 10px;
    box-sizing: border-box;
  }

  .img-list {
    margin-top: 20px;
    height: 320px;
    overflow-y: auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    // &:after {
    //   display: inline-block;
    //   width: 100%;
    //   content: "";
    // }
    img {
      width: 150px;
      height: 150px;
    }
  }

  .img-local {
    padding-top: 10px;
    border-top: 1px solid #ddd;

    .img-item {
      // width: 148px;
    }

    .upload-txt {
      display: inline-block;
      width: 100%;
      text-align: center;
    }
  }

  .img-ope {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    margin-top: 20px;

    .ope {
      width: 50%;
      display: flex;
      align-items: center;
      position: relative;

      .img-tree {
        position: absolute;
        top: 34px;
        left: 70px;
        z-index: 1000;
        border: 1px solid #ddd;
        width: 40%;
      }
    }
  }

  .error {
    color: red;
    cursor: pointer;
  }

  // ::v-deep.content{
  //   background: #E5E5E5;
  // }
  .conta {
    border: none;
    background: #f0f0f0;
  }

  .el-button--primary {
    color: #fff;
    background-color: #2587ff;
    border-color: #2587ff;
  }

  .el-link.el-link--primary {
    color: #2587ff;
  }

  .el-button--text {
    color: #2587ff;
  }
}
</style>
